export const chaveArmazenamentoToken = "helpexames-token";
export const chaveArmazenamentoIdSessao = "helpexames-idSessao";
export const chaveArmazenamentoSessaoNaoRenovada = "helpexames-sessaoNaoRenovada";
export const chaveArmazenamentoTermoBusca = "helpexames-termoBusca";

export const titleExamePublicado = "Exame publicado";
export const titleExameNaoPublicado = "Exame não publicado";
export const titleExameAtivo = "Ativo";
export const titleExameSuspenso = "Suspenso";

export const PAGINA_INICIAL = 1;
export const PEDIDOS_PAGINA_INICIAL = 10;
export const TAMANHO_MAXIMO_IMAGEM_EM_MB = 3;

export const USUARIO_ADMIN = 1;
export const USUARIO_PUBLICO = 2;

export const CARACTERE_ESPECIAL_URL_ID_EXAME = "$*";

export const ABA_VIGENCIA_ATUAL = "Vigência atual";
export const ABA_NOVA_VIGENCIA = "Nova vigência";

export const QTD_CARACTERES_PESQUISA = 2;

export const DESCRICAO_PROGRAMA_URGENCIA = "Programa de urgência";

export const ID_APELIDO_EXAME = 998;
export const DESCRICAO_APELIDO_EXAME = "Apelido";

export const MATERIAL_DIVERSOS = "DIVERSOS";

export const TAMANHO_MAXIMO_ANEXOS = 5;
export const QUANTIDADE_MAXIMA_ANEXOS = 5;
export const EXTENSOES_ANEXOS = ".jpeg, .png, .pdf, .jpg, .docx, .doc";

export const MENSAGEM_FALHA_ANEXO = "Falha ao anexar";

export const LABORATORIO_PSC_PADRAO_FILTROS = { id: 5, nome: "ANAL.CLI.VICOSA" };

export const HELP_MYPARDINI = {
  ID: 99,
  DESCRICAO: "HELP MYPARDINI",
  categorias: [
    { id: 1, descricao: "Imagem" },
    { id: 2, descricao: "Análises Clínicas" },
    { id: 4, descricao: "Veterinário" },
    { id: 5, descricao: "Informativo" }
  ]
};

export const SUBMENU_L2L = [
  {
    id: 1,
    nome: "L2L Geral"
  },
  {
    id: 2,
    nome: "L2L Configuração Avançada"
  }
];

export const ORIGENS_INTEGRACAO = {
  MYPARDINI: { apelidoUrl: "mypardini", authKey: "%MYPARDINI" },
  AGENDADOM: { apelidoUrl: "agendadom", authKey: "%AGENDADOM" }
};

export const CATEGORIAS_EXAME = {
  IMAGEM: 1,
  ANALISES_CLINICAS: 2,
  VACINA: 3,
  VETERINARIO: 4,
  INFORMATIVO: 5
};

export const ATRIBUTOS = {
  INFORMACOES_INTERNAS: 9,
  AREA: 5,
  CALENDARIO: 10,
  MARCACAO: 13,
  FORMATO_RESULTADO: 14,
  VOLUME_RECOMENDAVEL: 20,
  COMENTARIOS: 27,
  EXIGE_AGENDAMENTO: 42,
  TEMPO_JEJUM: 67,
  PROGRAMA_URGENCIA: 999
};

export const SITUACAO_EXAME = {
  ATIVO: "A",
  SUSPENSO: "S",
  CANCELADO: "C"
};

export const ORIGEM_ADMISSIVEL = {
  COBRANCA: "C"
};

export const PERFIL_USUARIO = {
  CLIENTE_LOJA: 1,
  COLABORADOR_PSC: 2,
  MEDICO: 3,
  CLIENTE_L2L: 4,
  COLABORADOR_L2L: 5
};

export const EMPRESAS = {
  PARDINI: {
    id: 1,
    nome: "Hermes Pardini MG",
    artigo: "no",
    apelido: "hermes-pardini-mg",
    gtm: "GTM-TTWPWC2",
    telefone: "(31) 3228-6200",
    whatsApp: null,
    siteEmpresa: "https://www.hermespardini.com.br",
    sitePoliticaPrivacidade:
      "https://www.hermespardini.com.br/politicas-de-privacidade",
    urlAgendamento:
      "https://www.hermespardini.com.br/csp/agendamento/HPardini.AgendamentoPub.Pagina.Principal.cls",
    urlResultado: "https://www.hermespardini.com.br/meusresultados/?empresa=1",
    urlTutorialResultado: "https://www.hermespardini.com.br/como-acessar-meus-exames"
  },
  CEMEDI: {
    id: 5,
    nome: "Sete Lagoas Imagem",
    artigo: "no",
    apelido: "cemedi-sete-lagoas",
    gtm: ""
  },
  PARDINISP: {
    id: 7,
    nome: "Hermes Pardini SP",
    artigo: "no",
    apelido: "hermes-pardini-sp",
    gtm: "GTM-TTWPWC2"
  },
  PADRAO: {
    id: 8,
    nome: "Padrão",
    artigo: "no",
    apelido: "padrao",
    gtm: "GTM-5MNZG3Q"
  },
  CMNG: {
    id: 15,
    nome: "Centro de Medicina",
    artigo: "no",
    apelido: "centro-de-medicina",
    gtm: "GTM-MGMDQ8L"
  },
  ECOAR: {
    id: 18,
    nome: "Ecoar",
    artigo: "na",
    apelido: "ecoar",
    gtm: "GTM-MT3PJ3B"
  },
  LABCLASS: {
    id: 19,
    nome: "LabClass",
    artigo: "no",
    apelido: "labclass",
    gtm: "GTM-5WPV8P3"
  },
  PAULOAZEVEDO: {
    id: 25,
    nome: "Paulo Azevedo",
    artigo: "no",
    apelido: "paulo-azevedo",
    gtm: ""
  },
  ODIVANIA: {
    id: 29,
    nome: "Odivânia",
    artigo: "na",
    apelido: "odivania",
    gtm: "GTM-MKMRSVZ"
  }
};

export const ETAPAS_EDICAO = {
  informacao_consolidada: "Informação consolidada",
  atributo: "Atributo",
  publicacao: "Publicação"
};

export const PALAVRAS_REDIRECIONAMENTO_BUSCA_EXAMES = {
  AGENDAMENTO: "agendar agendamento marcar marcacao",
  RESULTADO: "resultados"
};

export const TEXTO_FIXO_BUSCA_EXAMES = {
  RESULTADO: [
    {
      TITULO: "Resultado de exame",
      DESCRICAO: `Clique aqui para acessar os resultados dos seus exames. Para fazer o acesso tenha em mãos o código do cliente ou seu cpf e a senha de acesso.`
    },
    {
      TITULO: "Como acessar meu resultado de exame",
      DESCRICAO: "Tutorial de como acessar o resultado do exame."
    }
  ],
  AGENDAMENTO: [
    {
      TITULO: "Agendar exame",
      DESCRICAO: `Agende exames de imagem para agilizar o seu atendimento. 
        Nossos exames laboratoriais não requerem agendamento prévio. 
        Documentos necessários para agendamento: documentos com foto, pedido médico, carteirinha de convênio.`
    }
  ]
};

export const FRASE_INFO_CONSOLIDADA_ASSOCIADA =
  "Já existe uma informação de tempo de jejum consolidada associada a este exame.";
